import { render, staticRenderFns } from "./editDialogScgl.vue?vue&type=template&id=6b0ea1b3"
import script from "./editDialogScgl.vue?vue&type=script&lang=ts"
export * from "./editDialogScgl.vue?vue&type=script&lang=ts"
import style0 from "./editDialogScgl.vue?vue&type=style&index=0&id=6b0ea1b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports